// extracted by mini-css-extract-plugin
export default {"excludedRenderer":"styles_excluded-renderer__CRBMk"};